import {gql} from "@apollo/client";

export const LOGIN = gql`
    mutation login($loginInput: LoginInput!) {
        login(loginInput: $loginInput) {
            accessToken
            message
        }
    }
`;

export const CONFIRM_PASSWORD_RESET = gql`
    mutation ConfirmPasswordUpdate($token: String!, $newPassword: String!) {
        confirmPasswordUpdate(token: $token, newPassword: $newPassword)
    }
`;
